/**
 * Fred Olsen Cruise Lines Dynamica LTT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CabinDTO } from './cabinDTO';


export interface ShipDTO { 
    cruiseCode?: string;
    program?: string;
    activationDate?: string;
    shipName?: string;
    dtd?: number;
    cap?: number;
    holdCabins?: number;
    bookedCabins?: number;
    availableCabins?: number;
    occ?: number;
    forecastOcc?: number;
    paxBooked?: number;
    singlePaxBooked?: number;
    forecastOocDeparture?: number;
    durationDays?: number;
    cabins?: Array<CabinDTO>;
}

